import { usePageContext } from '@/contexts/PageContext/PageContext';

import { useSectionContext } from '../SectionContext';

export const useSection = () => {
  const { updateSectionContext, sectionKey } = useSectionContext();
  const {
    actions: { makeSectionVisible },
  } = usePageContext();

  const showSection = (): void => {
    updateSectionContext({ isSectionVisible: true });
    setTimeout(() => {
      makeSectionVisible(sectionKey);
    }, 10);
  };

  return { showSection };
};
